// extracted by mini-css-extract-plugin
export default {"backArrow":"BackArrow_backArrow__D-jwt"};